function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclExcaclamater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.3307 7.00156H11.3387M11.3307 15.0036V10.0023M21.3333 11.0026C21.3333 16.527 16.8552 21.0052 11.3307 21.0052C5.80629 21.0052 1.32812 16.527 1.32812 11.0026C1.32812 5.47817 5.80629 1 11.3307 1C16.8552 1 21.3333 5.47817 21.3333 11.0026Z",
    stroke: "#99ABA7",
    style: {
      stroke: "#99ABA7",
      stroke: "color(display-p3 0.6000 0.6706 0.6549)",
      strokeOpacity: 1
    },
    strokeWidth: 1.50039,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclExcaclamater);
export default __webpack_public_path__ + "static/media/eclExcaclamater.1b27d63098ad1d8d8ab4b9159b2410c9.svg";
export { ForwardRef as ReactComponent };